/* MONIÉ — global.js */
(function () {
  'use strict';
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };
  var debounce = function (fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; };

  /* ---------- Open/close drawers + search ---------- */
  var lastFocus = null;
  function open(id) {
    var el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (id === 'CartDrawer') renderCart();
    if (id === 'SearchModal') { var i = el.querySelector('[data-search-input]'); renderSearch(''); if (i) setTimeout(function () { i.focus(); }, 60); }
  }
  function close(el) { el.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; if (lastFocus) lastFocus.focus(); }

  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-drawer-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); open('SearchModal'); return; }
    if (e.target.closest('.drawer-close') || e.target.classList.contains('drawer-overlay') || e.target.closest('[data-search-close]')) {
      var d = e.target.closest('.drawer, .search-modal'); if (d) close(d);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var op = document.querySelector('.drawer[aria-hidden="false"], .search-modal[aria-hidden="false"]'); if (op) close(op); }
  });

  /* ---------- Cart ---------- */
  async function getCart() { return (await fetch('/cart.js')).json(); }
  async function updateCount() {
    try { var c = await getCart(); document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count ? c.item_count : ''; }); } catch (e) {}
  }
  async function renderCart() {
    var body = document.querySelector('[data-cart-body]'), foot = document.querySelector('[data-cart-foot]');
    if (!body) return;
    var c = await getCart();
    if (!c.items.length) {
      body.innerHTML = '<div class="cartd-empty"><h2 class="serif">Your cart is empty</h2><p>Have an account? <a class="link-u" href="/account/login" style="text-decoration:underline;">Log in</a> to check out faster.</p><a class="btn" href="/collections/all" style="margin-top:10px;border-radius:10px;">Continue shopping</a></div>';
      if (foot) foot.style.display = 'none'; return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = c.items.map(function (it, i) {
      var opts = it.product_has_only_default_variant ? '' : (it.variant_title || '');
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="cart-line"><img src="' + img + '" alt="" loading="lazy">' +
        '<div><div class="cart-line-t">' + it.product_title + '</div>' +
        (opts ? '<div class="cart-line-m">' + opts + '</div>' : '') +
        '<div class="cart-line-m">Qty ' + it.quantity + '</div>' +
        '<button class="cart-line-rm" data-line="' + (i + 1) + '">Remove</button></div>' +
        '<div class="cart-line-m">' + money(it.final_line_price) + '</div></div>';
    }).join('');
    var sub = document.querySelector('[data-cart-subtotal]'); if (sub) sub.textContent = money(c.total_price);
  }
  async function changeLine(line, qty) {
    await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }) });
    updateCount(); renderCart();
  }
  async function addToCart(id) {
    await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: id, quantity: 1 }) });
    updateCount(); open('CartDrawer');
  }
  document.addEventListener('click', function (e) {
    var rm = e.target.closest('.cart-line-rm'); if (rm) { changeLine(parseInt(rm.dataset.line, 10), 0); return; }
    var add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); var id = add.getAttribute('data-add'); if (!id) return; add.style.pointerEvents = 'none'; addToCart(id).finally(function () { add.style.pointerEvents = ''; }); }
  });

  /* ---------- PDP variant select ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-pdp-select]'); if (!sel) return;
    var form = sel.closest('form'); var atc = form && form.querySelector('[data-pdp-atc]');
    if (atc) atc.setAttribute('data-add', sel.value);
  });

  /* ---------- Product card: hover back image + arrows ---------- */
  document.querySelectorAll('[data-card]').forEach(function (card) {
    var media = card.querySelector('.mcard-media'); if (!media) return;
    var imgs = media.querySelectorAll('.mcard-img'); if (imgs.length < 2) return;
    var idx = 0, locked = false;
    function show(n) { idx = (n + imgs.length) % imgs.length; imgs.forEach(function (im, i) { im.classList.toggle('on', i === idx); }); }
    media.addEventListener('mouseenter', function () { if (!locked) show(1); });
    media.addEventListener('mouseleave', function () { if (!locked) show(0); });
    var prev = card.querySelector('[data-card-prev]'), next = card.querySelector('[data-card-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); locked = true; show(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); locked = true; show(idx + 1); });
  });

  /* ---------- Recently viewed (for search) ---------- */
  try {
    if (document.querySelector('.pdp')) {
      var nameEl = document.querySelector('.pdp-name'), priceEl = document.querySelector('.pdp-price'), imgEl = document.querySelector('.pdp-gallery img');
      if (nameEl) {
        var rec = JSON.parse(localStorage.getItem('monie_recent') || '[]');
        var item = { title: nameEl.textContent.trim(), price: priceEl ? priceEl.textContent.trim() : '', url: location.pathname, image: imgEl ? imgEl.src : '' };
        rec = rec.filter(function (r) { return r.url !== item.url; }); rec.unshift(item); rec = rec.slice(0, 4);
        localStorage.setItem('monie_recent', JSON.stringify(rec));
      }
    }
  } catch (e) {}

  /* ---------- Predictive search ---------- */
  function cardHTML(p) {
    return '<a href="' + p.url + '"><img src="' + (p.image || '') + '" alt="" loading="lazy"><div class="n">' + p.title + '</div>' + (p.price ? '<div class="p">' + p.price + '</div>' : '') + '</a>';
  }
  function renderSearch(q) {
    var box = document.querySelector('[data-search-results]'); if (!box) return;
    var html = '';
    var rec = [];
    try { rec = JSON.parse(localStorage.getItem('monie_recent') || '[]'); } catch (e) {}
    if (!q && rec.length) {
      html += '<div class="search-sec-h"><span>Recently viewed</span><button class="clear" data-search-clear>Clear</button></div><div class="search-row">' + rec.map(cardHTML).join('') + '</div>';
    }
    box.innerHTML = html;
    if (!q) return;
    fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (((data.resources || {}).results || {}).products) || [];
        var out = html;
        if (prods.length) {
          out += '<div class="search-sec-h"><span>Products</span></div><div class="search-row">' + prods.map(function (p) {
            return cardHTML({ url: p.url, title: p.title, price: p.price, image: (p.featured_image && p.featured_image.url) || p.image || '' });
          }).join('') + '</div>';
        } else {
          out += '<div class="search-sec-h"><span>No results for &ldquo;' + q + '&rdquo;</span></div>';
        }
        box.innerHTML = out;
      }).catch(function () {});
  }
  document.addEventListener('input', debounce(function (e) {
    if (e.target.matches('[data-search-input]')) renderSearch(e.target.value.trim());
  }, 220));
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-clear]')) { localStorage.removeItem('monie_recent'); renderSearch(''); }
  });

  /* ---------- Sticky transparent header ---------- */
  var header = document.querySelector('.site-header.is-home');
  if (header) {
    var onScroll = function () { header.classList.toggle('scrolled', window.scrollY > window.innerHeight * 0.7); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Click-to-play video ---------- */
  document.querySelectorAll('[data-video]').forEach(function (wrap) {
    var v = wrap.querySelector('video'); if (!v) return;
    wrap.addEventListener('click', function () { if (v.paused) { v.play(); } else { v.pause(); } });
    v.addEventListener('play', function () { wrap.classList.add('playing'); });
    v.addEventListener('pause', function () { wrap.classList.remove('playing'); });
    v.addEventListener('ended', function () { wrap.classList.remove('playing'); });
  });

  updateCount();
})();
